import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!this.videoElement) { return }
    if (this.element.dataset.vjsInitialized) { return }

    this.videoPlayer = videojs(this.videoElement)
    this.element.dataset.vjsInitialized = true
  }

  disconnect() {
    if (!this.videoPlayer) { return }

    try {
      this.videoPlayer.dispose()
    } catch(e) {}

    delete this.element.dataset.vjsInitialized
  }

  get videoElement() { return this.element.querySelector("video") }
}
